var Account, AccountState, ActionFactories, Breadcrumbs, EditGalleryPage, GridView, HeadingBar, Page, m;

m = require('mithril');

ActionFactories = require('../../state/ActionFactories');

AccountState = require('../../state/Account');

Account = require('../components/Account');

Page = require('../components/Page');

HeadingBar = require('../components/HeadingBar');

Breadcrumbs = require('../components/Breadcrumbs');

GridView = require('../components/GridView');

EditGalleryPage = {
  controller: function(args) {
    var ctrl, editGallery;
    editGallery = args.editGallery();
    ctrl = this;
    ctrl.id = m.prop(editGallery.id);
    ctrl.name = m.prop(editGallery.name);
    ctrl.updateDetails = function(e) {
      e.preventDefault();
      args.updateDetails(ctrl.id(), ctrl.name());
      return m.route('/admin');
    };
    return ctrl;
  },
  view: function(ctrl, args) {
    var account, editGallery, library;
    account = args.account();
    library = args.library();
    editGallery = args.editGallery();
    return m(Page, {
      account: account,
      content: [
        m(HeadingBar, {
          content: m(Breadcrumbs, {
            items: [
              {
                icon: 'home',
                title: 'Home',
                onclick: function() {
                  return m.route('/home');
                }
              }, {
                icon: 'warning',
                content: 'Admin',
                onclick: function() {
                  return m.route('/admin');
                }
              }, {
                content: 'Edit Gallery'
              }
            ]
          })
        }), m('h1', 'Edit Gallery'), m('h2', 'Details'), m('form', {
          onsubmit: ctrl.updateDetails
        }, [
          m('p', m('label', m('input[type=text][required=required]', {
            value: ctrl.id(),
            onchange: m.withAttr('value', ctrl.id)
          }))), m('p', m('label', m('input[type=text][required=required]', {
            value: ctrl.name(),
            onchange: m.withAttr('value', ctrl.name)
          }))), m('input[type=submit]')
        ]), m('h2', 'Images'), m(GridView, {
          photos: library.photos,
          onPhotoSelect: function(photo) {
            return args.togglePhoto(photo.name);
          },
          selectionFilter: function(photo) {
            return editGallery.photoIds.indexOf(photo.name.toString()) !== -1;
          }
        })
      ]
    });
  }
};

module.exports = function(store) {
  return m(EditGalleryPage, {
    account: function() {
      return store.getState().account;
    },
    library: function() {
      return store.getState().library;
    },
    editGallery: function() {
      return store.getState().editGallery;
    },
    updateDetails: function(id, name) {
      return store.dispatch(ActionFactories.galleryDetailsUpdated(id, name));
    },
    togglePhoto: function(id) {
      return store.dispatch(ActionFactories.libraryPhotoToggled(id));
    }
  });
};

//# sourceMappingURL=data:application/json;base64,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
